import { render, staticRenderFns } from "./SpacesTableau.vue?vue&type=template&id=8103a1e6&"
import script from "./SpacesTableau.vue?vue&type=script&lang=js&"
export * from "./SpacesTableau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports